import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.REACT_APP_ENDPOINT,
})

export const apiBlob = axios.create({
  baseURL: process.env.REACT_APP_ENDPOINT,
  responseType: "blob"
})